import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const CTA_IMAGE =
  'https://readdy.ai/api/search-image?query=Soft%20minimal%20banner%20background%20with%20subtle%20fashion%20product%20shapes%20in%20warm%20cream%20and%20sage%20green%20tones%2C%20airy%20and%20calm%2C%20gentle%20gradient%2C%20lots%20of%20negative%20space%2C%20editorial%20style%2C%20high%20detail&width=1600&height=600&seq=cta-usfans-2026&orientation=landscape';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-secondary-50">
      <div className="absolute inset-0">
        <img src={CTA_IMAGE} alt="" aria-hidden="true" className="h-full w-full object-cover object-top opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary-50/60 to-secondary-50"></div>
      </div>
      <div className="relative mx-auto max-w-4xl px-4 md:px-6 py-16 md:py-24 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">{t('cta_title')}</h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
          {t('cta_text')}
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 whitespace-nowrap transition-colors"
          >
            {t('cta_primary')}
            <i className="ri-arrow-right-up-line ml-2" aria-hidden="true"></i>
          </a>
          <Link
            to="/article/what-is-a-usfans-spreadsheet"
            className="w-full sm:w-auto rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-700 hover:bg-background-100 whitespace-nowrap transition-colors"
          >
            {t('cta_secondary')}
          </Link>
        </div>
      </div>
    </section>
  );
}